import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-health-insurance-transaction-response',
  templateUrl: './health-insurance-transaction-response.component.html',
  styleUrls: ['./health-insurance-transaction-response.component.css']
})
export class HealthInsuranceTransactionResponseComponent implements OnInit {
  successSection : boolean;
  FailureSection : boolean;
  loading : boolean;
  txnId: string;
  error: string;
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private router: ActivatedRoute, private serviceURLService: serviceURLService) { }

  ngOnInit() {
    this.router.queryParams.subscribe(params => {
      console.log(params);
      if(params.status === 'true'){
        this.txnId = params.txnRefNo;
        this.successSection = true;
      }else{
        this.FailureSection = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    

}
